import { render } from "./IconPriceRules.vue?vue&type=template&id=66076908"
import script from "./IconPriceRules.vue?vue&type=script&lang=js"
export * from "./IconPriceRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__